import { TooltipProvider } from '@/components/ui/tooltip';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { BackToTop } from './components/BackToTop';
import { CartSheet } from './components/cart/CartSheet';
import { OrderConfirmationSheet } from './components/order/OrderConfirmationSheet';
import { ToastProvider } from './components/ToastProvider';
import { ProductDetailProvider } from './contexts/ProductDetailContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { useBranchInit } from './hooks/useBranchInit';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import Index from './pages/Index';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ProductDetailPage from './pages/ProductDetailPage';
import RefundPolicy from './pages/RefundPolicy';
import TermsOfUse from './pages/TermsOfUse';

const queryClient = new QueryClient();

function AppContent() {
  useBranchInit();

  return (
    <BrowserRouter>
      <ProductDetailProvider>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/products" element={<Index />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/product/:slug" element={<ProductDetailPage />} />
        </Routes>
        <CartSheet />
        <OrderConfirmationSheet />
        <BackToTop />
      </ProductDetailProvider>
    </BrowserRouter>
  );
}

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TooltipProvider>
          <ToastProvider>
            <AppContent />
          </ToastProvider>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
